import { render } from "./HomeBestDispensaryCms.vue?vue&type=template&id=2c3ee53a"
import script from "../js/home-best-dispensary-cms.js?vue&type=script&lang=js"
export * from "../js/home-best-dispensary-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__